import {
  CheckInOut,
  WorkOrderCheckInOut,
  WorkOrderSearchCheckInOut,
  ZoneStatusItem
} from '../../../interfaces/WorkOrder/WorkOrder'
import { actionTypes } from '../types/actionTypes'
import { Search } from '../types/reducerTypes'

/*
 * Copyright 2022-07-26 por Alfonso Moya Ecomsur Holding S.A ©
 * Detalle: se crea checkActions por cambio a useReducer + Context
 */

export const checkActions = () => {
  const setSearchedId = (search: string): actionTypes => ({
    type: 'setSearchedId',
    payload: search
  })

  const setWorkOrder = (
    workOrderSearch: WorkOrderCheckInOut | undefined
  ): actionTypes => ({
    type: 'setWorkOrder',
    payload: workOrderSearch
  })

  const setWorkOrderSearchCheckInOut = (
    workOrderSearchCheckInOut: WorkOrderSearchCheckInOut | undefined
  ): actionTypes => ({
    type: 'setWorkOrderSearchCheckInOut',
    payload: workOrderSearchCheckInOut
  })

  const setIsWorkOrderId = (isWorkOrderId: boolean): actionTypes => ({
    type: 'setIsWorkOrderId',
    payload: isWorkOrderId
  })
  const setError = (error: string | undefined): actionTypes => ({
    type: 'setError',
    payload: error
  })
  const setLoading = (loading: boolean): actionTypes => ({
    type: 'setLoading',
    payload: loading
  })
  const setWasRegistered = (wasRegistered: boolean): actionTypes => ({
    type: 'setWasRegistered',
    payload: wasRegistered
  })
  const setDriver = (driver: string): actionTypes => ({
    type: 'setDriver',
    payload: driver
  })
  const setShowCheckInDescription = (
    isShowDescription: boolean
  ): actionTypes => ({
    type: 'setShowCheckInDescription',
    payload: isShowDescription
  })
  const setShowCheckOutDescription = (
    isShowDescription: boolean
  ): actionTypes => ({
    type: 'setShowCheckOutDescription',
    payload: isShowDescription
  })
  const setShowModal = (show: boolean): actionTypes => ({
    type: 'setShowModal',
    payload: show
  })
  const setSearch = (search: Search): actionTypes => ({
    type: 'setSearch',
    payload: search
  })
  const setWorkOrderDispatcher = (dispatcher: string): actionTypes => ({
    type: 'setWorkOrderDispatcher',
    payload: dispatcher
  })
  const setCheckInWorkOrder = (
    checkinWorkOrder: CheckInOut | undefined
  ): actionTypes => ({
    type: 'setCheckInWorkOrder',
    payload: checkinWorkOrder
  })
  const setShowPickingRouteStatus = (
    isPickingStatus: boolean
  ): actionTypes => ({
    type: 'setShowPickingRouteStatus',
    payload: isPickingStatus
  })
  const setZonesStatus = (zonesStatus: ZoneStatusItem[]): actionTypes => ({
    type: 'setZonesStatus',
    payload: zonesStatus
  })
  const setLoadingZones = (loadingZones: boolean): actionTypes => ({
    type: 'setLoadingZones',
    payload: loadingZones
  })

  return {
    setSearchedId,
    setWorkOrder,
    setWorkOrderSearchCheckInOut,
    setIsWorkOrderId,
    setError,
    setLoading,
    setWasRegistered,
    setDriver,
    setShowCheckInDescription,
    setShowCheckOutDescription,
    setShowModal,
    setSearch,
    setWorkOrderDispatcher,
    setCheckInWorkOrder,
    setShowPickingRouteStatus,
    setZonesStatus,
    setLoadingZones
  }
}
